// extracted by mini-css-extract-plugin
module.exports = {"shp2-detail-C":"C_shp2-detail-C__joR_c"};